var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeguardingTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8447,
    cy: 36.0693,
    r: 8.07728,
    stroke: "#161614",
    strokeWidth: 3.75747
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6163 56.06V66.2762H28.0701V56.06C28.0701 49.5579 33.3411 44.2869 39.8432 44.2869C46.3453 44.2869 51.6163 49.5579 51.6163 56.06Z",
    stroke: "#161614",
    strokeWidth: 3.75747
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4326 68.0451L16.6888 56.5941C16.3491 55.1766 17.4236 53.8143 18.8812 53.8143H38.2356C39.2604 53.8143 40.1563 54.5055 40.4163 55.4968L43.7076 68.0451H19.4326Z",
    stroke: "#F30002",
    strokeWidth: 3.75747
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08286 24.1567L28.3196 10.0445C31.6847 7.57581 32.9424 6.69749 34.2536 6.38387C35.3888 6.11234 36.5733 6.1233 37.7033 6.4158C39.0084 6.75363 40.2496 7.65508 43.5685 10.1856L63.1136 25.0883C65.3556 26.7978 66.1667 27.4386 66.7363 28.2126L68.2495 27.0992L66.7363 28.2126C67.2302 28.884 67.6028 29.6366 67.8372 30.4365C68.1074 31.3587 68.1252 32.3923 68.1252 35.2116V57.7441C68.1252 59.9515 68.1236 61.4903 68.0226 62.6868C67.9236 63.8603 67.7391 64.5325 67.47 65.0407C66.9414 66.0392 66.1248 66.8558 65.1263 67.3845C64.6181 67.6535 63.9459 67.838 62.7724 67.937C61.5759 68.038 60.0371 68.0396 57.8297 68.0396H14.1781C11.9707 68.0396 10.4319 68.038 9.23538 67.937C8.06188 67.838 7.3897 67.6535 6.8815 67.3845C5.883 66.8558 5.06644 66.0392 4.53776 65.0407C4.26868 64.5325 4.0842 63.8603 3.98517 62.6868C3.8842 61.4903 3.88264 59.9515 3.88264 57.7441V34.4212C3.88264 31.5383 3.90119 30.4814 4.18226 29.542C4.42602 28.7274 4.81338 27.9628 5.32606 27.2844C5.9172 26.5021 6.75844 25.8619 9.08286 24.1567Z",
    stroke: "#161614",
    strokeWidth: 3.75747
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeguardingTeams);
export default __webpack_public_path__ + "static/media/Safeguarding-Teams.486af7233d491a4bced2ac5fbcaac4b0.svg";
export { ForwardRef as ReactComponent };